import React from 'react';
import { Typography } from "@mui/material";
import ReusableBVTTable from './ReusableBVTTable';
import { 
  createTableRowData, 
  getFilteredItems, 
  createSectionHeader 
} from '../bvtTableBuilders';

/**
 * Simplified Budget Table Component
 * @param {Object} budgetData - Contains baseline, penultimate, current contract summaries
 * @param {Object} classes - CSS classes object
 * @param {boolean} isModal - Whether table is in modal view
 */
const BudgetTable = ({ budgetData, classes, isModal }) => {
  if (!budgetData?.baseline_contract_summary?.contract_structure ||
      !budgetData?.penultimate_contract_summary?.contract_structure ||
      !budgetData?.current_contract_summary?.contract_structure) {
    return <Typography style={{ textAlign: "center" }}>--</Typography>;
  }

  const {
    baseline_contract_summary: baseline,
    penultimate_contract_summary: penultimate,
    current_contract_summary: current,
  } = budgetData;

  // Get budget items
  const currentBudgetItems = Object.keys(current.contract_structure.Budget || {});
  
  // Create table rows data
  const rows = [];

  // Lump Sum Budget Section
  rows.push(createSectionHeader("Lump Sum Budget"));
  
  const lumpSumItems = getFilteredItems(currentBudgetItems, 'LS');
  lumpSumItems.forEach(item => {
    rows.push(createTableRowData(item, baseline, penultimate, current, 'Budget'));
  });

  // GMP Budget Section  
  rows.push(createSectionHeader("GMP Budget"));
  
  const gmpItems = getFilteredItems(currentBudgetItems, 'GMP');
  gmpItems.forEach(item => {
    rows.push(createTableRowData(item, baseline, penultimate, current, 'Budget'));
  });

  // Calculate totals for summary row
  const lumpSumTotal = lumpSumItems.reduce((sum, item) => {
    return sum + (current.contract_structure.Budget[item] || 0);
  }, 0);
  
  const gmpTotal = gmpItems.reduce((sum, item) => {
    return sum + (current.contract_structure.Budget[item] || 0);
  }, 0);

  const baselineLSTotal = lumpSumItems.reduce((sum, item) => {
    return sum + (baseline.contract_structure.Budget[item] || 0);
  }, 0);
  
  const baselineGMPTotal = gmpItems.reduce((sum, item) => {
    return sum + (baseline.contract_structure.Budget[item] || 0);
  }, 0);

  const penultimateLSTotal = lumpSumItems.reduce((sum, item) => {
    return sum + (penultimate.contract_structure.Budget[item] || 0);
  }, 0);
  
  const penultimateGMPTotal = gmpItems.reduce((sum, item) => {
    return sum + (penultimate.contract_structure.Budget[item] || 0);
  }, 0);

  // Add totals row
  const totalBaseline = baselineLSTotal + baselineGMPTotal;
  const totalPenultimate = penultimateLSTotal + penultimateGMPTotal;
  const totalCurrent = lumpSumTotal + gmpTotal;
  
  rows.push({
    item: "Total Overall Budget",
    baselineValue: totalBaseline,
    penultimateValue: totalPenultimate,
    currentValue: totalCurrent,
    variancePenultimateToCurrent: totalCurrent - totalPenultimate,
    varianceBaselineToCurrent: totalCurrent - totalBaseline,
    isSectionHeader: true
  });

  return (
    <div>
      <p className="bvt-table-title">Budget</p>
      <ReusableBVTTable
        rows={rows}
        classes={classes}
        isModal={isModal}
        ariaLabel="budget-table"
      />
    </div>
  );
};

export default BudgetTable;